import { render, staticRenderFns } from "./ProductoCrud.vue?vue&type=template&id=bc0149cc&"
import script from "./ProductoCrud.vue?vue&type=script&lang=js&"
export * from "./ProductoCrud.vue?vue&type=script&lang=js&"
import style0 from "./ProductoCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports